export default __webpack_public_path__ + "static/media/header-orcamento.43bb3897.jpg";